import { Link } from 'react-router-dom';

export default function QualityCommitmentSection() {
  return (
    <section className="py-20 px-6 bg-gradient-to-b from-[#F8F6FA] to-white">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl border border-[#E8E8E8] p-8 md:p-10 shadow-sm">
          {/* ヘッダー */}
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F0EBF5]">
              <i className="ri-palette-line text-lg text-[#8B6BAE]"></i>
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-[#2C2C2C]" style={{ fontFamily: 'Playfair Display, serif' }}>
              MeVERだけの品質へのこだわり
            </h3>
          </div>

          {/* 説明文 */}
          <p className="text-base text-[#4A4A4A] leading-relaxed mb-6">
            Atelier Folioは、クリエイターの声から生まれたMeVER独自設計です。<br className="hidden md:block" />
            外見が似た製品が存在しますが、私たちは「見えない部分」にこそこだわりました。
          </p>

          {/* 3つのポイント */}
          <div className="space-y-3 mb-6">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-[#8B6BAE] text-lg"></i>
              </div>
              <p className="text-sm md:text-base text-[#4A4A4A]">
                画面とイラストレーターを守る厳選スエード内装
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-[#8B6BAE] text-lg"></i>
              </div>
              <p className="text-sm md:text-base text-[#4A4A4A]">
                精密調整されたペンホルダーのマグネット磁力
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-[#8B6BAE] text-lg"></i>
              </div>
              <p className="text-sm md:text-base text-[#4A4A4A]">
                iPadをしっかり保護する最適化された吸着力
              </p>
            </div>
          </div>

          {/* フッターメッセージ */}
          <div className="border-t border-[#E8E8E8] pt-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <p className="text-sm text-[#6B6B6B]">
                長時間の創作活動を支える、本物の設計品質。<br />
                <span className="font-medium text-[#8B6BAE]">『MeVER』ロゴ刻印</span>が、その証です。
              </p>
              <a
                href="https://lin.ee/d6PoCFQ6"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#F0EBF5] text-[#8B6BAE] text-sm font-medium rounded-full hover:bg-[#E8E0F0] transition-colors cursor-pointer whitespace-nowrap group"
              >
                優先案内を受取る
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
